import React, { useState, Component, useMemo, useEffect } from "react";
import DataTable from "../../_Components/DataTable";
import _ from "lodash";
import SwalMessage from "../../_Components/SwalMessage";
import ApiPublicPromoCodeService from "../../../../core/api/api.publicPromoCode";
let showPrice = Intl.NumberFormat("en-US");
function DataGridUsedPromoCodeByUser(props) {
  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }
  async function callApiService(item, flag) {
    console.log("item", item);
    const response = await ApiPublicPromoCodeService.removePublicPromoCode({
      id: item.allPublicPromoCodeViewModel.id,
      Status: !item.allPublicPromoCodeViewModel.isDeleted,
    });
    if (response.succeeded == true)
      document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "userPhoneNumber",
      Header: "شماره موبایل",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div className="ltr">{row.original.userPhoneNumber}</div>
      ),
    },
    {
      accessor: "promoCode",
      Header: "کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "amusmentServiceName",
      Header: "نام سرویس",
      minWidth: "100px",
    },
    {
      accessor: "createdTimeBasketItem",
      Header: "تاریخ خرید",
      minWidth: "100px",
    },
    {
      accessor: "checkInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    {
      accessor: "originalPrice",
      Header: "قیمت اصلی",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {showPrice.format(row.original.originalPrice)}
        </div>
      ),
    },
    {
      accessor: "salePrice",
      Header: "قیمت فروش سایت",
      minWidth: "130px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {showPrice.format(row.original.salePrice)}
        </div>
      ),
    },
    {
      accessor: "promoCodeDiscountPrice",
      Header: "مبلغ تخفیف",
      align: "center",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div className="text-center">
          {showPrice.format(row.original.promoCodeDiscountPrice)}
        </div>
      ),
    },
    {
      accessor: "price",
      Header: "قیمت نهایی کاربر",
      minWidth: "130px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {showPrice.format(row.original.price)}
        </div>
      ),
    },
    {
      accessor: "cancelStatus",
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div
          className={` rounded-pill text-center px-5 py-1 d-flex justify-content-center align-items-center width-fit mx-auto ${
            row.original.cancelStatus === "جدید"
              ? "bg-light-primary text-primary"
              : row.original.cancelStatus === "پیگیری_کنسلی"
                ? "bg-light-info text-info"
                : row.original.cancelStatus === "کنسل_شد"
                  ? "bg-light-danger text-danger"
                  : row.original.cancelStatus === "رد_درخواست_کنسلی"
                    ? "bg-light-warning text-warning"
                    : "bg-light text-secondary"
          }`}
        >
          {row.original.cancelStatus}
        </div>
      ),
    },
    {
      accessor: "agentCommisionPrice",
      Header: "کمیسیون",
      minWidth: "100px",
      Cell: ({ row }) => (
        <>
          {row.original.agentCommisionPrice == 0 ||
          row.original.agentCommisionPrice == null
            ? "درانتظار"
            : showPrice.format(row.original.agentCommisionPrice)}
        </>
      ),
    },
    {
      accessor: "promoCodePublicationTypeS",
      Header: "نوع کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "agentCommissionSettlementStatus",
      Header: " تسویه",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={
            row.original.agentCommissionSettlementStatus === "پرداخت_شده"
              ? "text-green"
              : row.original.agentCommissionSettlementStatus ===
                    "عدم_واریز_به_کیف_پول" ||
                  row.original.agentCommissionSettlementStatus ===
                    "برگشت_از_کیف_پول"
                ? "text-danger"
                : ""
          }
        >
          {row.original.agentCommissionSettlementStatus}
        </div>
      ),
    },
    // {
    //   accessor: "AgentCommissionIsSettled",
    //   Header: "تسویه",
    //   minWidth: "100px",
    //   Cell: ({ row }) => (
    //     <>
    //       {row.original.agentCommissionIsSettled == true
    //         ? "انجام شده"
    //         : "درانتظار"}
    //     </>
    //   ),
    // },
    {
      Header: "عملیات",
      accessor: "",
      ///                 minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <i
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {}}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-custom-class="tooltip-dark"
            title={showDetail(row.original.details)}
            data-bs-delay-hide="1000"
          >
            <b>i</b>
          </i>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={props.data} />
    </div>
  );
}

export default DataGridUsedPromoCodeByUser;
